import { render, staticRenderFns } from "./createCandidate.vue?vue&type=template&id=84b9c854"
import script from "./createCandidate.vue?vue&type=script&lang=js"
export * from "./createCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports